<template>
  <div class="main-panel wheel-panel">
    <div class="wheel-panel-content">
      <Wheel ref="wheel" @result="spinCompleted" />
    </div>

    <div v-if="showResult" class="wheel-results-wrap">
      <div class="wheel-results-bg" />
      <div class="wheel-results">
        <h2>Congratulations</h2>
        <p v-html="resultText" />
        <p v-if="video"><a :href="video">{{ video }}</a></p>
        <p v-if="make">Make a screenshot and show at your visit</p>
        <p class="wheel-results-footer">*Limit of one coupon per transaction</p>
      </div>
    </div>

    <img class="background-image" :src="background ? background : null" />
  </div>
</template>

<script>
import Wheel from './Wheel';
import { mapState } from 'vuex';

export default {
  name: 'WheelPanel',
  components: {
    Wheel
  },
  data() {
    return {
      showResult: false,
      spinning: false,
      spinText: 'Spin!',
      resultText: '',
      video: '',
      make: true
    };
  },
  computed: mapState({
    spins: state => state.spins,
    name: state => state.data.name || 'Wheel of Fortune',
    winningText: state => state.data.winningText || 'You get: <b>%s</b>',
    background: state => state.data.background || '',
    prizes: state => state.available,
    headerWidth: state => state.size
  }),
  methods: {
    // Called when the Wheel has stopped spinning.
    spinCompleted(index) {
      const prize = this.prizes[index];
      this.spinning = false;
      this.spinText = 'Spin again!';
      this.resultText = this.winningText.replace('%s', prize.name);
      if (prize.video) {
        this.video = prize.video;
      }
      this.make = prize.make;
      setTimeout(() => {
        this.showResult = true;
      }, 2000);
    },

    // Called by the Spin button. Requests the Wheel to start spinning.
    startSpin() {
      if (!this.spinning) {
        this.$store.commit('updateAvailable');
        if (this.prizes.length === 0) return;

        this.spinning = true;
        this.spinText = 'Spinning...';
        this.resultText = '&#8203;';
        this.$refs.wheel.startSpin();
      }
    }
  },
  mounted() {
    this.startSpin();
  }
};
</script>

<style>
.wheel-panel-content {
  position: relative;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: stretch;
  min-height: 100%;
  height: 100vh;
  z-index: 2;
}
.wheel-header-area {
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex: 0 0 auto;
  font-size: 20px;
  font-weight: bold;
  text-align: left;
  background-color: rgba(241, 244, 249, 0.3);
}
.wheel-header {
  margin: 12px;
  min-width: 300px;
}
.wheel-header-title {
  display: inline-block;
  border-radius: 3px;
}
.wheel-footer-area {
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex: 0 0 auto;
  background-color: rgba(241, 244, 249, 0.3);
}
.wheel-footer {
  padding: 12px;
  font-size: 18px;
  border-radius: 3px;
}
.wheel-result {
  margin-bottom: 6px;
}
.background-image {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.4;
}
.show-options-container {
  position: fixed;
  top: 12px;
  right: 12px;
  z-index: 3;
}
.show-records-container {
  position: fixed;
  bottom: 12px;
  right: 12px;
  z-index: 3;
}
.wheel-results-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #000;
  top: 0;
  left: 0;
  z-index: 100;
  opacity: 0.8;
}
.wheel-results {
  position: absolute;
  z-index: 1000;
  top: 30%;
  left: 0;
  width: 80vw;
  margin-left: 10vw;
  border-radius: 8px;
  padding: 30px;
  box-sizing: border-box;
  background: #fff url("../assets/bg.png");
  background-size: cover;
  text-shadow: 0 0 5px #fff;
}
.wheel-results-footer {
  font-size: 80%;
}
.wheel-results-wrap {
  z-index: 50;
}
</style>
